import { qiniu } from '../../util/qiniu';

export default {
    data() {
        return {
            uploadData: {
                token: '',
            },
        };
    },
    async created() {
        this.uploadData.token = await qiniu.fetchQiniuToken(this);
    },
    methods: {
        joinCDN(url) {
            return `${qiniu.imgCDN}/${url}`;
        },

        safeBase64(url) {
            url = btoa(url);
            url = url.split('+').join('-');
            url = url.split('/').join('_');
            return url;
        },
    },
};
